<div id="chargingStationPlacement" data-cy="charging-station-placement">
  <div [formGroup]="control" class="form">
    <ife-title
      [title]="'modules.evcQuote.steps.chargingStationDetails.steps.placement.title' | translate"
      data-cy="charging-station-placement-title"
    ></ife-title>

    <div class="flex flex-wrap checkboxPadding justify-center">
      <div class="justify-center w-full sm:w-auto">
        <ife-checkbox
          [id]="chargingStationPlacement.inside"
          [attr.data-cy]="chargingStationPlacement.inside"
          [value]="chargingStationPlacement.inside"
          formControlName="value"
          [image]="'./assets/evc/img/inside.svg'"
          [caption]="'modules.evcQuote.steps.chargingStationDetails.steps.placement.options.inside' | translate"
        >
        </ife-checkbox>

        <div
          *ngIf="init && control.get('value').value === chargingStationPlacement.inside"
          class="mt-4 sm:mt-8 text-xs text-gray-400 text-center full-width sm:max-w-md"
          data-cy="preselected-disclaimer"
        >
          {{ "modules.evcQuote.general.preSelected" | translate }}
        </div>
      </div>

      <div class="justify-center w-full sm:w-auto">
        <ife-checkbox
          [id]="chargingStationPlacement.outsideWall"
          [attr.data-cy]="chargingStationPlacement.outsideWall"
          [value]="chargingStationPlacement.outsideWall"
          formControlName="value"
          [image]="'./assets/evc/img/outsideWall.svg'"
          [caption]="'modules.evcQuote.steps.chargingStationDetails.steps.placement.options.outsideWall' | translate"
        >
        </ife-checkbox>

        <div
          *ngIf="init && control.get('value').value === chargingStationPlacement.outsideWall"
          class="mt-4 sm:mt-8 text-xs text-gray-400 text-center full-width sm:max-w-md"
          data-cy="preselected-disclaimer"
        >
          {{ "modules.evcQuote.general.preSelected" | translate }}
        </div>
      </div>

      <div class="justify-center w-full sm:w-auto">
        <ife-checkbox
          [id]="chargingStationPlacement.outsidePole"
          [attr.data-cy]="chargingStationPlacement.outsidePole"
          [value]="chargingStationPlacement.outsidePole"
          formControlName="value"
          [image]="'./assets/evc/img/outsidePole.svg'"
          [caption]="'modules.evcQuote.steps.chargingStationDetails.steps.placement.options.outsidePole' | translate"
        >
        </ife-checkbox>
        <div
          *ngIf="init && control.get('value').value === chargingStationPlacement.outsidePole"
          class="mt-4 sm:mt-8 text-xs text-gray-400 text-center full-width sm:max-w-md"
          data-cy="preselected-disclaimer"
        >
          {{ "modules.evcQuote.general.preSelected" | translate }}
        </div>
      </div>
    </div>

    <ife-navigation
      [showNext]="control.valid"
      [showPrevious]="true"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
    >
    </ife-navigation>
  </div>
</div>
